import { useMemo } from "react";
import { formatClass } from "../../../utils/formatters";

export const useFilteredGoals = (
  goalData = [],
  selectedLocations,
  selectedMetrics,
  selectedDisplayed,
  isTotalView
) => {
  return useMemo(() => {
    return (
      goalData &&
      goalData.filter((goal) => {
        if (isTotalView) {
          return selectedMetrics.some((metric) => formatClass(goal.title) === formatClass(metric));
        }
        const matchesLocation = selectedLocations.some(
          (loc) => formatClass(goal.locationName) === formatClass(loc)
        );
        const matchesMetric = selectedMetrics.some(
          (metric) => formatClass(goal.title) === formatClass(metric)
        );
        const matchesDisplay = selectedDisplayed.some(
          (display) => goal.active === (display.toLowerCase() === "active")
        );
        return matchesLocation && matchesMetric && matchesDisplay;
      })
    );
  }, [goalData, selectedLocations, selectedMetrics, selectedDisplayed, isTotalView]);
};
